import { DetailedHTMLProps, HTMLAttributes } from 'react';
import classNames from 'classnames';

import { useFormTheme } from '../../contexts/FormTheme/FormThemeContext';

const JabraLegend: React.FC<
  DetailedHTMLProps<HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>
> = ({ className, dangerouslySetInnerHTML }) => {
  const { primaryTextColor } = useFormTheme();

  return (
    <p
      className={classNames('mt-2 text-xs font-normal', className, primaryTextColor)}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
    />
  );
};
export default JabraLegend;
